export default __webpack_public_path__ + "static/media/arrowLeft.56cbbe6d.svg";